import React from "react";
import { Box, Typography, Card } from "@mui/material";
import "../../styles/components-styles/CourseCard.css"; // Import the external CSS file

// Reusable Component for Course Sections
const CourseCard = ({ title, subTitle, content }) => {
  return (
    <Card className="creative-writing-course-card">
      <Box className="creative-writing-course-header">
        <Typography className="creative-writing-course-title">
          {title}
        </Typography>
        {subTitle && (
          <Typography className="creative-writing-course-subtitle">
            {subTitle}
          </Typography>
        )}
      </Box>
      <Typography className="creative-writing-course-content">
        {content}
      </Typography>
    </Card>
  );
};

const CreativeWritingCourse = () => {
  const courses = [
    {
      title: "1. Genres of Writing",
      content:
        "Dive into the fascinating world of writing! From narrative and descriptive pieces to fiction, non-fiction, and academic writing, we explore various styles to help children find their unique voice.",
    },
    {
      title: "2. Vocabulary for Writing",
      content:
        "Expand your child’s word bank! Learn how to choose the right words to convey thoughts with precision and impact.",
    },
    {
      title: "3. Creating Ideas to Write",
      content:
        "Say goodbye to writer’s block! Through fun activities, we spark creative thinking, encouraging children to generate fresh ideas.",
    },
    {
      title: "4. Developing Characters",
      content:
        "Craft memorable characters! Learn the art of making characters come alive on the page with unique traits and personalities.",
    },
    {
      title: "5. Storytelling",
      subTitle: "Fiction and Non-Fiction",
      content:
        "Master the art of storytelling! Whether it’s crafting an imaginative tale or recounting a real-life event, your child will learn to engage and captivate readers.",
    },
    {
      title: "6. Forms of Writing",
      content:
        "Explore a variety of writing forms, including essays, letters, speeches, and more, tailored to suit different purposes.",
    },
    {
      title: "7. Grammar in Action",
      content:
        "Blend grammar seamlessly into writing! Develop a strong foundation in grammar to ensure clarity and accuracy.",
    },
    {
      title: "8. Communication Skills",
      content:
        "Express ideas effectively! Learn how to communicate through writing with confidence and clarity.",
    },
    {
      title: "9. Creative Thinking",
      content:
        "Foster originality and critical thinking. We teach children to think beyond the ordinary and articulate their ideas innovatively.",
    },
  ];

  return (
    <Box className="creative-writing-container">
      <Typography className="creative-writing-title">
        Creative Writing Course
      </Typography>
      <Typography className="creative-writing-description">
        Welcome To The World Of Creative Writing <br /> Unlock your child’s
        potential to create magic with words. At our creative writing course, we
        nurture young minds to become confident writers who can express their
        thoughts effortlessly.
      </Typography>
      <Typography className="creative-writing-subtitle">
        What We Offer
      </Typography>

      <Box className="creative-writing-courses-container">
        <Box className="creative-writing-courses-layout">
          <Box className="creative-writing-left-grid">
            {courses.slice(0, 4).map((course, index) => (
              <CourseCard
                key={index}
                title={course.title}
                content={course.content}
              />
            ))}
          </Box>

          <Box className="creative-writing-center-card">
            <CourseCard title={courses[4].title} content={courses[4].content} />
          </Box>

          <Box className="creative-writing-right-grid">
            {courses.slice(5).map((course, index) => (
              <CourseCard
                key={index + 5}
                title={course.title}
                subTitle={course.subTitle}
                content={course.content}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CreativeWritingCourse;
